// config.js
const config = {
  apiUrl: 'https://meragym.com/admins/public/api',
  //apiUrl: 'http://127.0.0.1:8000/api',
};
export default config;
